import { render } from "./EditSensor.vue?vue&type=template&id=372b6eba&scoped=true&ts=true"
import script from "./EditSensor.vue?vue&type=script&lang=ts"
export * from "./EditSensor.vue?vue&type=script&lang=ts"

import "./EditSensor.vue?vue&type=style&index=0&id=372b6eba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372b6eba"]])

export default __exports__